module.exports = __webpack_public_path__ + "static/media/arcdev1-home.d4aee162.PNG";